import {useState} from 'react';
import ContentModal from '../../organisms/ContentModal';
import {useReport} from '../../../contexts/ReportContext';

import StatArea, {DefaultStatsLebel} from '../../organisms/StatArea';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import HappyNumberLabel from '../../atoms/HappyNumberLabel';
import styled from 'styled-components';
import SimpleBar from 'simplebar-react';

const ValueStr = styled.div`
  font-size: 50px;
  font-weight: bold;
  line-height: 50px;
  margin-bottom: 27px;
  text-align: center;
`;

export default function VenueReportDevices() {
  const report = useReport();
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  if (!report.state.data) {
    return (
        <>
          <StatArea
              labelWithInfo={
                <LabelWithInfo
                    text={'Rooms active'}
                    labelclassname={'stats-name-label'}
                >
                  <div></div>
                </LabelWithInfo>
              }
              delta={null}
              button={null}
          >
            <ValueStr>
              <HappyNumberLabel text={'0'}/>
            </ValueStr>
            <DefaultStatsLebel text={'rooms/floors'}/>
          </StatArea>
        </>
    );
  }

  let data = report.state.data.rooms || [];

  return (
      <>
        <StatArea
            labelWithInfo={
              <LabelWithInfo
                  text={'Rooms active'}
                  labelclassname={'stats-name-label'}
              >
                <div>
                  You can see the active rooms/floors that issued playlists in
                  the selected period. Tap 'See more' to view the list.
                </div>
              </LabelWithInfo>
            }
            delta={null}
            button={
              <button className="dark-button stats-action" onClick={openModal}>
                <span>See more</span>
              </button>
            }
        >
          <ValueStr>
            <HappyNumberLabel text={data.length.toLocaleString('en-US')}/>
          </ValueStr>
          <DefaultStatsLebel
              text={`${data.length != 1 ? 'rooms/floors' : 'room/floor'}`}/>
        </StatArea>

        <ContentModal closeModal={closeModal} isOpen={modalIsOpen}
                      statmodal={1}>
          <div className="fixed-header">
            <h3>Rooms active</h3>
            <div className="scroll-header">
              <div className="scroll-header-columns">
                <div className="scroll-header-column">
                  <span>Room/Floor</span>
                </div>
                <div className="scroll-header-column last">
                  <div className="dummy-label">
                    {data.map((item, i) => {
                      return (
                          <div
                              key={i}
                              style={{
                                top: i * -1,
                              }}
                          >
                            {item.value}
                          </div>
                      );
                    })}
                  </div>
                  <span>Tracks</span>
                </div>
              </div>
            </div>
          </div>

          <SimpleBar forceVisible="y" autoHide={false} className="scroll-area">
            <div
                className={`scroll-content ${
                    data.length ? 'has-items' : 'no-items'
                }`}
            >
              <table className="scroll-table">
                <tbody>
                {data.map((item, i) => {
                  if (item.room) {
                    let room = item.room;
                    return (
                        <tr key={i} className="tr">
                          <td className="right-border">
                            {room.name}
                          </td>
                          <td className="last right-border">{item.value}</td>
                        </tr>
                    );
                  } else if (item.device) {
                    let device = item.device;
                    return (
                        <tr key={i} className="tr">
                          <td className="right-border">
                            {device.floor_name ||
                                'NO NAME'} ({device.customer_id ||
                              ''})
                            {' / '}
                            {device.device_name}
                          </td>
                          <td className="last right-border">{item.value}</td>
                        </tr>
                    );
                  } else {
                    return (<tr key={i} className="tr">
                      <td className="right-border">

                      </td>
                      <td className="last right-border">{item.value}</td>
                    </tr>);
                  }
                })}
                </tbody>
              </table>
            </div>
          </SimpleBar>
        </ContentModal>
      </>
  );
}
